export default "__VITE_ASSET__1g0YzlbM__";